export default "__VITE_ASSET__DiOR0lpm__"